import '../../style/index.less';
import './index.less';
import './rtl.less';
// style dependencies
import '../../empty/style';
import '../../input/style';
